module.exports = __webpack_public_path__ + "img/smiley-orange.22d4efdd.svg";